import { Component, ViewChild, OnInit, Inject } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { ChangeDetectorRef } from '@angular/core';
// import { MsalUserService } from 'src/app/Service/msaluser.service';
import { UserManagementService } from 'src/app/Service/user-management.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UserProfileComponent } from 'src/app/modals/user-profile/user-profile.component';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { Bank, BANKS } from './demo-data';

import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { ResponseCodes } from '@azure/msal-common/dist/utils/Constants';
import { SessionExpireComponent } from '../session-expire/session-expire.component';
/**
 * @title Table with pagination
 */
/**
 * @title Table with sorting
 */
export interface BankGroup {
  name: string;
  banks: Bank[];
}
@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss'],
})
export class UserViewComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  /*add for mat sort */

  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  /* Mat chip input */
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: any = [];

  /* Mat chip input */
  public matChipArray = [];

  namedata = '';
  roledata = '';
  statedata = [];
  phonedata = '';
  districtdata = [];
  mandidata = '';
  displayedColumns: string[] = [
    'personName',
    'role',
    'states',
    'district',
    'phoneNo',
  ];
  userlist = [];
  userdata;
  selectedIndex = -1;
  dataSource;
  userId = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
  hidepagination: boolean;
  accessToken;
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  filterbyname = '';
  filterbyrole = '';
  filterbystate = [];
  filterbyphone = '';
  filterbymandi = '';
  filterbydistrict = [];
  pagechangeevent;
  dataSourcelist;
  datashow = true;
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  rolebased = [{ role: 'Trader' }, { role: 'Farmer' }];
  stateselect;
  datarole;
  fetchList;
  totalcount;
  totalData;
  totalCountData = [];

  /** Label of the search placeholder */

  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(
    1
  );

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<
    Bank[]
  >(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true })
  multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  constructor(
    public _userService: UserManagementService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) {
    // this.datarole =  localStorage.getItem("UserRole");
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }

  ngOnInit() {
    // this.datarole =  localStorage.getItem("UserRole")
    setTimeout(() => {
      this.datarole = localStorage.getItem('UserRole');

      this.getAlluser();
    }, 1000);

    (this.hidepagination = true),
      // var tolen = this.msalService.GetAccessToken()
      this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.accessToken = localStorage.getItem('msal.idtoken');
    this.getStaticData();
    // this._userService.getStates().subscribe(data => {
    //   this.stateselect = data
    //   this.states = this.stateselect.result.data;
    //   // this.spinner.hide();
    // });

    // load the initial bank list
    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    // listen for search field value changes
    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });

    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });
    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.setToggleAllCheckboxState();
      });
  }

  suche() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search State';
    }, 5);
  }

  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }

  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }
  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search District';
    }, 5);
  }
  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected districtSetInitialValue() {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelectDistrict.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter(
      (bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1
    );
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter(
      (item: any) => item.toLowerCase().indexOf(search) > -1
    );
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach((el) => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict =
        filteredLength > 0 &&
        filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict =
        filteredLength > 0 &&
        filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }

  // districtFilterMyOptions(items) {
  //   this.selectDistrict = [];
  //   if(this.districtMultiCtrl.value.length===0){

  //   }else{
  //   this.districtMultiCtrl.value.forEach(element => {
  //     //this.selectDistrict.push(element.districtName);
  //     this.selectDistrict= this.selectDistrict.concat(element.districtName);
  //   });
  // }
  // }

  getStaticData() {
    this._userService.getStaticUserData().subscribe((data) => {
      this.totalData = data;
      this.totalCountData = this.totalData.result.data;
    });
  }

  response;
  /*.......................................................GET ALL USER......................................................... */
  getAlluser() {
    this.spinner.show();
    var postdata = {
      userId: '',
      userRole: '',
      name: '',
      state: '',
      documentStatus: '',
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: '',
      pageNumber: 0,
      pageSize: 10,
      adminRole: this.datarole,
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      // this.response=data;
      // if (this.response.code === 408) {
      //   const dialogRef = this.dialog.open(SessionExpireComponent, {
      //     width: '60%',
      //     height: '71%',

      //   });
      //   dialogRef.afterClosed().subscribe(result => {
      //   });
      // }
      // else if(this.response.code == 401){
      //   this.router.navigateByUrl("/");
      //   // const dialogRef = this.dialog.open(SessionExpireComponent, {
      //   //   width: '60%',
      //   //  data:this.response.message
      //   //  });
      //   //  dialogRef.afterClosed().subscribe(result => {

      //   // });
      // }

      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.totalcount = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //setTimeout(() => this.dataSource.sort = this.sort);

      this.spinner.hide();
    });
  }

  /*............................................GET ALL USER BY FILTER.............................................. */

  filterbytext = '';
  searchdata = '';
  filtersearch = false;
  userSuggesstion: any = [];

  // searchfilter(){
  //   this.filtersearch = true ;
  //   this.filterbytext =  this.searchdata;
  //    if (this.filterbytext == "" || this.filterbytext == undefined )
  //   {

  //     this.getAlluser();

  //   }else{

  //     var postdata = {
  //     "userId": "",
  //     "userRole": "",
  //     "name": "",
  //     "state": "",
  //     "documentStatus": "",
  //     "district": "",
  //     "search": this.filterbytext,
  //     "marketPlace": "",
  //     "mobileNo": "",
  //     "pageNumber":0,
  //     "adminRole": localStorage.getItem("UserRole")
  //   }
  //     this._userService.getAllUser(postdata).subscribe(data => {
  //       this.userdata = data
  //       this.userlist = this.userdata.result.data.list
  //       this.paginationProperty = this.userdata.result.data
  //       this.length = this.paginationProperty.totalItems
  //       this.previousPageIndex = this.paginationProperty.previousPageIndex;
  //       this.hasNextPage = this.paginationProperty.hasNextPage;
  //       this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
  //       // this.pageIndex = this.paginationProperty.pageNumber
  //       this.dataSource = new MatTableDataSource(this.userlist);
  //       this.dataSource.sort = this.sort;
  //       this.spinner.hide();
  //     });
  //   }

  // }

  autoSuggestionUser(param) {
    this._userService.autoSuggestionUser(param.target.value).subscribe((res: any) => {
      console.log('Result is  : ', res.result.data);
      this.userSuggesstion = res.result.data;
    });
  }
  changeFn(event: any) {
    // if(this.filtersearch = false) {
    if (event.isTrusted == true) {
      // if(this.filtersearch = false) {
      // this.searchfilter();
      this.applyfilter(false);
      
    }
    //  }
  }

  // filterUserDetail(data:any,filtername){
  //     if(filtername == "name"){
  //       this.filterbyname = data
  //     }
  //     else if(filtername == "role"){
  //        this.filterbyrole = data
  //     }
  //     else if(filtername == "state"){
  //         this.filterbystate = data
  //     }
  //     else if(filtername == "phoneNo"){

  //       this.filterbyphone = data
  //    }
  //     else if(this.filterbyname=="" || this.filterbyname == undefined || this.filterbyrole == "" || this.filterbyrole == undefined|| this.filterbyphone == "" || this.filterbyphone == undefined){
  //       this.getAlluser()
  //     }
  //     // else(data == "" || data == undefined){
  //     //   this.getAlluser()
  //     // }

  //     var postdata = {
  //       "userId": "",
  //         "userRole": this.filterbyrole,
  //         "name": this.filterbyname,
  //         "state": this.filterbystate,
  //         "documentStatus":"",
  //         "district": "",
  //         "marketPlace": "",
  //         "mobileNo": this.filterbyphone,
  //         "pageNumber": 0,
  //         "adminRole": localStorage.getItem("UserRole")
  //     }
  //   this._userService.getAllUser(postdata).subscribe(data => {
  //     this.userdata = data
  //     this.userlist = this.userdata.result.data.list
  //     this.paginationProperty = this.userdata.result.data
  //     this.length = this.paginationProperty.totalItems
  //     this.previousPageIndex = this.paginationProperty.previousPageIndex;
  //     this.hasNextPage = this.paginationProperty.hasNextPage;
  //     this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
  //     this.pageIndex = this.paginationProperty.pageNumber

  //     this.dataSource = new MatTableDataSource(this.userlist);
  //     this.dataSource.sort = this.sort;
  //     this.spinner.hide();
  //   });
  // }

  /*.........................................PAGINATION CONFIG................................................. */

  public getServerData(event?: PageEvent) {
    // this.spinner.show();/* Commented by shivam modi */
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {
      // this.applyfilter();
      //  this.applyfilter();
      var postdata = {
        userId: '',
        userRole: this.filterbyrole,
        name: this.filterbyname,
        state: this.filterbystate.join(','),
        documentStatus: '',
        district: this.filterbydistrict.join(','),
        search: this.filterbytext,
        marketPlace: this.filterbymandi,
        mobileNo: this.filterbyphone,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    } else {
      var postdata = {
        userId: '',
        userRole: '',
        name: '',
        state: '',
        documentStatus: '',
        district: '',
        search: '',
        marketPlace: '',
        mobileNo: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }
  /*Add by shivam modi */
  companyname;
  documentStatus;
  mandi;
  personName;
  phoneNo;
  role;
  states;
  district;
  taluk;
  numberOfTrees;
  treeType;
  commTradeInterest;
  reqFrequency;
  aboutUs;
  profile_Image;
  address;
  showDocument(data) {
    this.datashowtrader = false;
    this.datashow = false;
    this.datashowfarmer = true;
    this.avtar = false;
    this.Viewprofile = true;
    if (data.role == 'TRADER') {
      this.datashowtrader = true;
      this.datashowfarmer = false;
    }
    if (data.profile_Image == null) {
      this.avtar = true;
    }
    this.companyname = data.company;
    this.documentStatus = data.documentStatus;
    this.mandi = data.mandi;
    this.personName = data.personName;
    this.phoneNo = data.phoneNo;
    this.role = data.role;
    this.states = data.states;
    this.district = data.district;
    this.taluk = data.taluk;
    this.numberOfTrees = data.numberOfTrees;
    this.treeType = data.treeType;
    this.commTradeInterest = data.commTradeInterest;
    this.reqFrequency = data.reqFrequency;
    this.aboutUs = data.aboutUs;
    this.profile_Image = data.profile_Image;
    this.address = data.address;
    this.documentStatus = data.documentStatus;
  }

  showViews() {
    // this.spinner.show();
    // window.location.reload();
    this.datashow = true;
    this.Viewprofile = false;
    this.spinner.show();
    var postdata = {
      userId: '',
      userRole: '',
      name: '',
      state: '',
      documentStatus: '',
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: '',
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      this.dataSource = new MatTableDataSource(this.userlist);
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //setTimeout(() => this.dataSource.sort = this.sort);

      this.spinner.hide();
    });
  }
  /*Add by shivam modi */
  /*Export csv file */
  apidata;
  maindata;
  filename;
  exportcsvdata = false;

  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyfilter(true);
      var postdata = {
        userId: '',
        userRole: this.filterbyrole,
        name: this.filterbyname,
        state: this.filterbystate.join(','),
        district: this.filterbydistrict.join(','),
        search: this.filterbytext,
        marketPlace: this.filterbymandi,
        mobileNo: this.filterbyphone,
        documentStatus: '',
      };
      this._userService.getAllUserpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Users.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        userId: '',
        userRole: '',
        name: '',
        state: '',
        district: '',
        search: '',
        marketPlace: '',
        mobileNo: '',
        documentStatus: '',
      };
      this._userService.getAllUserpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Users.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }

  /*mat input chips  */
  Fruit;
  chipInput;
  add(event: MatChipInputEvent, inputName): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.fruits.push(value);
    }

    // Clear the input value
    // event.chipInput!.clear();
    inputName.value = '';

    // this.fruitCtrl.setValue(null);
  }
  // change(data: any, filtername) {

  filterbyname1;
  applyfilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = [];
    this.statedata.forEach((ele: any) => {
      totalState.push(ele.stateName);
    });
    if (
      checkEmpty &&
      !this.searchdata &&
      !this.roledata &&
      totalState.length == 0 &&
      this.districtdata.length == 0
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbytext = this.searchdata;
      this.filterbyname = this.namedata;
      this.filterbyrole = this.roledata;
      this.filterbystate = totalState;
      this.filterbyphone = this.phonedata;
      this.filterbydistrict = this.districtdata;
      this.filterbymandi = this.mandidata;

      // if(this.filterbyname == " " && this.filterbyrole == " " && this.filterbystate == " " && this.filterbyphone == " ")
      // {
      //      this.getAlluser();
      // }else{

      let indexname = this.matChipArray.findIndex((x) => x.tag === 'name');

      let indexrole = this.matChipArray.findIndex((x) => x.tag === 'role');
      let indexstate = this.matChipArray.findIndex((x) => x.tag === 'state');
      let indexphone = this.matChipArray.findIndex((x) => x.tag === 'phone');
      let indexdistrictdata = this.matChipArray.findIndex(
        (x) => x.tag === 'district'
      );
      let indexdmandi = this.matChipArray.findIndex((x) => x.tag === 'mandi');
      if (this.namedata != '') {
        if (indexname > -1) {
          this.matChipArray[indexname].name = 'Name' + ':' + this.namedata;
        } else {
          if (this.namedata != '' && this.namedata != undefined) {
            this.matChipArray.push({
              name: 'Name' + ':' + this.namedata,
              tag: 'name',
              flag: true,
            });
          }
        }
      }

      if (this.roledata != '') {
        if (indexrole > -1) {
          this.matChipArray[indexrole].name = 'Role' + ':' + this.roledata;
        } else {
          if (this.roledata != '' && this.roledata != undefined) {
            this.matChipArray.push({
              name: 'Role' + ':' + this.roledata,
              tag: 'role',
              flag: true,
            });
          }
        }
      }

      if (totalState != null) {
        totalState.forEach((ele) => {
          // if (ele.indexstate > -1) {
          //   this.matChipArray[ele.indexstate].name = "State" + ":" + totalState;
          // } else {
          //   if (totalState != null && totalState != undefined) {
          //     this.matChipArray.push({ 'name': "State" + ":" + totalState, 'tag': 'state', 'flag': true })
          //   }
          // }
          this.matChipArray.push({
            name: 'State' + ':' + ele,
            tag: 'state',
            flag: true,
          });
        });
      }

      if (this.phonedata != '') {
        if (indexphone > -1) {
          this.matChipArray[indexphone].name = 'Phone' + ':' + this.phonedata;
        } else {
          if (this.phonedata != '' && this.phonedata != undefined) {
            this.matChipArray.push({
              name: 'Phone' + ':' + this.phonedata,
              tag: 'phone',
              flag: true,
            });
          }
        }
      }

      if (this.districtdata != null) {
        this.districtdata.forEach((ele) => {
          this.matChipArray.push({
            name: 'District' + ':' + ele,
            tag: 'district',
            flag: true,
          });
        });
        // if (indexdistrictdata > -1) {
        //   this.matChipArray[indexdistrictdata].name = "District" + ":" + this.districtdata;
        // } else {
        //   if (this.districtdata != "" && this.districtdata != undefined) {
        //     this.matChipArray.push({ 'name': "District" + ":" + this.districtdata, 'tag': 'district', 'flag': true })
        //   }
        // }
      }
      if (this.mandidata != '') {
        if (indexdmandi > -1) {
          this.matChipArray[indexdmandi].name = 'Mandi' + ':' + this.mandidata;
        } else {
          if (this.mandidata != '' && this.mandidata != undefined) {
            this.matChipArray.push({
              name: 'Mandi' + ':' + this.mandidata,
              tag: 'mandi',
              flag: true,
            });
          }
        }
      }

      // if(this.filterbyrole !=  undefined || this.filterbyname !=  undefined ||this.filterbystate  !=  undefined )

      var postdata = {
        userId: '',
        userRole: this.filterbyrole,
        name: this.filterbyname,
        state: this.filterbystate.join(','),
        documentStatus: '',
        district:
          this.filterbydistrict && this.filterbydistrict.length > 0
            ? this.filterbydistrict.join(',')
            : '',
        marketPlace: this.filterbymandi,
        search: this.filterbytext,
        mobileNo: this.filterbyphone,
        pageNumber: 0,
        pageSize: 10,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'name') {
      this.matChipArray.splice(index, 1);
      this.namedata = '';
    }
    if (tag === 'role') {
      this.matChipArray.splice(index, 1);
      this.roledata = '';
    }
    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(
        (x) => removedState[0].name === 'State:' + x.stateName
      );
      val.splice(i, 1);
      // this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      // this.bankMultiCtrl.setValue(this.statedata);
    }
    if (tag === 'phone') {
      this.matChipArray.splice(index, 1);
      this.phonedata = '';
    }
    if (tag === 'district') {
      let removedDistrict: any = this.matChipArray.splice(index, 1);
      let val = JSON.parse(JSON.stringify(this.districtdata));
      let i = val.findIndex(
        (x) => removedDistrict[0].name === 'District:' + x.districtName
      );
      val.splice(i, 1);
      this.districtMultiCtrl.setValue(val);
    }
    if (tag === 'mandi') {
      this.matChipArray.splice(index, 1);
      this.mandidata = '';
    }

    this.applyfilter(false);
  }

  /*====================================================View Profile ================================================================ */
  city: string;
  name: string;
  food_from_modal: string;

  openDialog(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '60%',
      height: '71%',
      data: { name: data.personId },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /* open model pop up */
  /*====================================================View Profile ================================================================ */

  /*====================================================Column Based Export Functionality ================================================================ */

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(UserExportData, {
      width: '62%',
      height: '71%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(true);
              var postdata = {
                userId: '',
                userRole: this.filterbyrole,
                name: this.filterbyname,
                state: this.filterbystate.join(','),
                documentStatus: '',
                district: this.filterbydistrict.join(','),
                marketPlace: this.filterbymandi,
                search: this.filterbytext,
                mobileNo: this.filterbyphone,
                reportKeyList: Result,
              };
              this._userService.getAllUserpdf(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_Users';
                anchor.href = url;
                anchor.click();
              });
            } else {
              var postdata = {
                userId: '',
                userRole: '',
                name: '',
                state: '',
                district: '',
                search: '',
                marketPlace: '',
                mobileNo: '',
                documentStatus: '',
                reportKeyList: Result,
              };
              this._userService.getAllUserpdf(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_Users.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
}

@Component({
  selector: 'user-export-data',
  templateUrl: 'user-export-data.html',
})
export class UserExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<UserExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'User Name', value: 'Name', isSelected: false },
      { id: 2, viewValue: 'Address', value: 'Address', isSelected: false },
      { id: 3, viewValue: 'Phone Number', value: 'PhoneNo', isSelected: false },
      { id: 4, viewValue: 'Role', value: 'Role', isSelected: false },
      { id: 5, viewValue: 'Company', value: 'Company', isSelected: false },
      { id: 6, viewValue: 'Mandi', value: 'Mandi', isSelected: false },
      { id: 7, viewValue: 'State', value: 'States', isSelected: false },
      { id: 8, viewValue: 'District', value: 'District', isSelected: false },
      { id: 9, viewValue: 'Taluk', value: 'Taluk', isSelected: false },
      { id: 10, viewValue: 'Village', value: 'Village', isSelected: false },
      {
        id: 11,
        viewValue: 'Number of Trees',
        value: 'NumberOfTrees',
        isSelected: false,
      },
      { id: 12, viewValue: 'About Us', value: 'AboutUs', isSelected: false },
      {
        id: 13,
        viewValue: 'Frequency for Requirement',
        value: 'ReqFrequency',
        isSelected: false,
      },
      { id: 14, viewValue: 'Email Id', value: 'EmailId', isSelected: false },
      { id: 15, viewValue: 'Rating', value: 'Rating', isSelected: false },
      {
        id: 16,
        viewValue: 'Commodity Trade Interested',
        value: 'CommTradeInterest',
        isSelected: false,
      },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
